import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, PROJECTLOGOPRIMARY, PROJECTCAPTCHASITEKEY, NFTAPIBASENAME,PAYBITOAPIBASENAME, MAXTIMELIMITFOREMAILOTP, MAXTIMELIMITFORPHONEOTP, PROJECTCLIENTSIDEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, sendOtpInEmail, sendOtpInPhone,setSessionData,getAllSessionData,manipulateCartAfterLoggedIn } from '../helpers/Library';
import Loader from '../commons/Loader';
import Cookies from "js-cookie";




const Login = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(true);


    /* Method defination for getting user details */
   let getUserDetails = (uuid) => {
        let payload = {
            uuid : uuid
        }
        setShowLoader(true);
        callAPI('post' ,PAYBITOAPIBASENAME + '/user/GetUserDetails',payload,true).then((res) => {
            let response = res.data;
            console.log(response);
            let userResult = response.userResult
            setSessionData('brokerId',userResult.brokerId)
            setSessionData('email',userResult.email)
            setSessionData('firstName',userResult.firstName)
            setSessionData('profilePic',userResult.profilePic);
            setSessionData('isLoggedInExchange','true');
            //setSessionData('loginPlatform','paybito');
            //addMarketplaceUser(uuid)
            setTimeout(() => {
                props.history.push("/");
            }, 2000);
            
        },(error)=>{
            showHttpError(error)
        })
    }

    /* Method defination for calling API add user market place */
    let addMarketplaceUser = (uuid) => {
        let payload = {
            userUuid : uuid
        }
        setShowLoader(true);
        callAPI('post' ,PAYBITOAPIBASENAME + '/nft/market/addMarketplaceUser',payload,true).then((res) => {
            let response = res.data;
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                props.history.push("/");
            }
            
            
        },(error)=>{
            showHttpError(error)
        })
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        let queryParams = props.match.params.id
        console.log('/session/' + queryParams)
        queryParams = JSON.parse(atob(queryParams))
        console.log(queryParams);
        let exchangeDomain = window.location.origin
        if(exchangeDomain.indexOf('localhost') != -1){
            exchangeDomain = 'https://trade.paybito.com/'
        }
        const brokerId = queryParams.brokerId || 'PAYB18022021121103';

        Cookies.set(PROJECTNAMEALIAS + "broker_id", brokerId, { expires: 127 });
        callAPI('get', 'https://accounts.paybito.com/api/home/getBrokerWiseExchangeInfo?brokerId=' + brokerId, false).then((res) => {
            let response = res.data.value[0];

            console.log('brokerrsss', response);

            localStorage.setItem('nftBrokerExchangeName', response.exchange)
            localStorage.setItem('nftBrokerCompanyName', response.company_name)
            if(localStorage.getItem('nftBrokerExchangeName').toLowerCase() === 'paybito'){
                 localStorage.setItem('nftBrokerlogo', 'https://www.paybito.com/wp-content/themes/paybito-theme/images/logo-white-paybito.png')
            }else{
                
                localStorage.setItem('nftBrokerlogo', response.exchange_logo)
            }
            localStorage.setItem('nftBrokerId', response.broker_id)
            localStorage.setItem('nftBrokerDomain', window.location.origin)
            localStorage.setItem('nftBrokerloginRedirectionDomain', window.location.origin + '?login-for=nft')


            // setExchangeLogo(response.exchangeLogo)

            setSessionData('uuid',queryParams.uuid)
            setSessionData('token',queryParams.token)
            console.log(getAllSessionData())
            getUserDetails(getAllSessionData().uuid);

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
       
        // let cart  = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
        // if(cart != null && cart != undefined){
        //     for(let i=0;i<cart.length;i++){
        //         manipulateCartAfterLoggedIn(cart[i].id,'add');
        //     }
        // }
       
       
    }, []);

    return (
        <Fragment>

            <Loader show={showLoader} />
        </Fragment>
    );
}

export default Login;